export default __webpack_public_path__ + "static/dinner-hero-a1e497ddbcc1d8a4bf27737630de4b0d.jpg";